import { createAction } from 'redux-actions'

export const QUICK_ASS_CATEGORY_CLICKED = 'Quick ass category link clicked'
export const TRIGGER_CTA_ANALYTICS = 'Trigger cta analytics'
export const TRIGGER_FOOTER_NAV_ANALYTICS = 'Trigger footer nav analytics'

const triggerFooterAnalytics = createAction(TRIGGER_FOOTER_NAV_ANALYTICS)
const triggerQuickAssCategoryAnalytics = createAction(QUICK_ASS_CATEGORY_CLICKED)
const triggerCtaAnalytics = createAction(TRIGGER_CTA_ANALYTICS)

const trackFooterNavigation = (name) => async (dispatch) => {
  dispatch(triggerFooterAnalytics(name))
}

const trackQuickAssCategoryLinks = (name) => async (dispatch) => {
  dispatch(triggerQuickAssCategoryAnalytics(name))
}

const trackCtaNavigation = (name) => async (dispatch) => {
  dispatch(triggerCtaAnalytics(name))
}

export const actionCreators = {
  trackFooterNavigation,
  trackQuickAssCategoryLinks,
  trackCtaNavigation,
}
